import { render } from "./BuildingMetric.vue?vue&type=template&id=e5f76c98&ts=true"
import script from "./BuildingMetric.vue?vue&type=script&lang=ts"
export * from "./BuildingMetric.vue?vue&type=script&lang=ts"

import "./BuildingMetric.vue?vue&type=style&index=0&id=e5f76c98&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BuildingMetric.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5f76c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5f76c98', __exports__)) {
    api.reload('e5f76c98', __exports__)
  }
  
  module.hot.accept("./BuildingMetric.vue?vue&type=template&id=e5f76c98&ts=true", () => {
    api.rerender('e5f76c98', render)
  })

}


export default __exports__